import { useAppContext } from '@mobile-mapping/providers';
import { Component } from 'solid-js';

export const ExperimentToggle: Component<{ name: string }> = (props: {
  name: string;
}) => {
  const { experiments, setExperiments } = useAppContext();

  const handleToggleClick = (e: Event): void => {
    e.preventDefault();
    const newValue = !(experiments()[props.name] ?? false);
    setExperiments({
      ...experiments(),
      [props.name]: newValue,
    });
  };

  return (
    <div class="flex">
      <span
        class="whitespace-nowrap flex-1 text-base-content"
        onClick={handleToggleClick}
      >
        {props.name}
      </span>
      <modus-wc-switch
        size="sm"
        value={experiments()[props.name] ?? false}
        disabled={false}
        on:inputChange={handleToggleClick}
      />
    </div>
  );
};
